/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */
import Jsona from 'jsona';
import * as API from '../utils/api';
import Types from '../constants/actionTypes';
import { applicationError } from './notificationActions';
import { fetchAllWorkPackages } from './workPackageActions';
import Store from '../store/store';

const dataFormatter = new Jsona();

const currentCadenceId = () => Store.getState().cadenceReducer.cadence?.id;

export function getCadence(id = 'current') {
  const endpoint = `cadences/${id}`;
  return (dispatch) => {
    dispatch({ type: Types.REQUEST_CADENCE });
    return API.get(endpoint)
      .then((response) => {
        if (response?.data) {
          const cadence = dataFormatter.deserialize(response);

          if (cadence) dispatch({ type: Types.SET_CADENCE, cadence });

          dispatch({
            type: Types.RECEIVE_ALL_WORK_PACKAGES,
            cadenceId: cadence ? cadence.id : 0
          });
        } else {
          // const currentUser = Store.getState().userReducer.user;
          // if (
          //   currentUser &&
          //   currentUser.default_team &&
          //   !currentUser.default_team.kanban
          // ) {
          //   dispatch(applicationError('No sprint has been started'));
          // }
          dispatch({ type: Types.NO_CADENCE });
        }
      })
      .catch((error) => {
        dispatch({ type: Types.NO_CADENCE });
        dispatch(applicationError(error));
      });
  };
}

export function getAllCadences() {
  return (dispatch) => {
    dispatch({ type: Types.REQUEST_CADENCE });
    return API.get('cadences')
      .then((response) => {
        const cadences = dataFormatter.deserialize(response);
        dispatch({ type: Types.RECEIVE_CADENCES, cadences });
      })
      .catch((error) => {
        dispatch(applicationError(error));
        dispatch({ type: Types.REQUEST_CADENCE_FAILED });
      });
  };
}

export function updateCadence(cadenceId, data) {
  return (dispatch) => {
    dispatch({ type: Types.SEND_CADENCE, cadence: data.cadence });
    return API.put(`cadences/${cadenceId}`, data)
      .then((response) => response.json())
      .then((response) => {
        const cadence = dataFormatter.deserialize(response.cadence);

        dispatch({ type: Types.UPDATE_CADENCE, cadence });
        dispatch(getAllCadences());
        dispatch(fetchAllWorkPackages());
      })
      .catch((error) => {
        dispatch(applicationError(error));
      });
  };
}

export function createCadence(data, handleUnprocessable) {
  return (dispatch) => {
    dispatch({ type: Types.SEND_CADENCE });
    return API.post('cadences', data, handleUnprocessable)
      .then(() => {
        dispatch(getAllCadences());
        dispatch(fetchAllWorkPackages());
      })
      .catch((error) => dispatch(applicationError(error)));
  };
}

export function deleteCadence(cadenceId) {
  return (dispatch) => {
    dispatch({ type: Types.SEND_CADENCE });
    return API.del(`cadences/${cadenceId}`)
      .then(() => dispatch(getAllCadences()))
      .catch((error) => dispatch(applicationError(error)));
  };
}

export function restoreCadence(cadenceId) {
  return (dispatch) => {
    dispatch({ type: Types.SEND_CADENCE });
    return API.put(`cadences/${cadenceId}/restore`)
      .then(() => dispatch(getAllCadences()))
      .catch((error) => dispatch(applicationError(error)));
  };
}

export function cadenceBurndown(cadenceId) {
  return (dispatch) => {
    dispatch({ type: Types.SEND_CADENCE });
    return API.get(`cadences/${cadenceId}/burndown`)
      .then((response) => {
        dispatch({
          type: Types.GET_CADENCE_BURNDOWN_DATA,
          cadenceId,
          burndownData: response
        });
      })
      .catch((error) => dispatch(applicationError(error)));
  };
}

export function updateBurndownData(cadenceId, graphData) {
  return (dispatch) =>
    dispatch({
      type: Types.GET_CADENCE_BURNDOWN_DATA,
      cadenceId,
      burndownData: graphData
    });
}

export function updateCadencesStore(cadence) {
  return (dispatch) =>
    dispatch({
      cadence,
      type: Types.UPDATE_CADENCE,
      cadenceId: currentCadenceId() // needed by work package reducer
    });
}

export function deleteCadencesStore(cadenceId) {
  return (dispatch) =>
    dispatch({
      cadence: Store.getState().cadenceReducer.cadences.find(
        (c) => c.id === cadenceId
      ),
      type: Types.DELETE_CADENCE,
      cadenceId: currentCadenceId() // needed by work package reducer
    });
}

export function clearNextCadence() {
  return (dispatch) =>
    dispatch({
      type: Types.CLEAR_NEXT_CADENCE
    });
}
